// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { SettingOut } from './settingOut.zod.ts';

export const SettingsSectionOut = zod.object({
  "description": zod.string(),
  "key": zod.string(),
  "name": zod.string(),
  "settings": zod.array(SettingOut)
});

export type SettingsSectionOut = zod.input<typeof SettingsSectionOut>;
export type SettingsSectionOutOutput = zod.output<typeof SettingsSectionOut>;
